import { SIZE, Stack, Text } from '@quinyx/ui';
import { ReactNode } from 'react';

type ActionCardProps = {
  title: string;
  description: string;
  children: ReactNode;
};

const ActionCard = ({ title, description, children }: ActionCardProps) => (
  <Stack spacing={SIZE.S}>
    <Stack spacing={SIZE.XS}>
      <Text variant="headlineHeavy">{title}</Text>
      <Text variant="smallRegular" color="SurfaceOnSurfaceAlt">
        {description}
      </Text>
    </Stack>
    <Stack alignItems="flex-end">{children}</Stack>
  </Stack>
);

export default ActionCard;
